export class QBProcessAuthorizationCodeRequest{
    public code!:string;
    public realmId!:string;
    public state!:string;
    public nonce!:string;
}